module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/~/entities/maps/xml.json
// module id = 255
// module chunks = 0